import { DatePipe } from '@angular/common';
import { FileManager } from '../source/fileManager.core';
export type filterType = number;
export let filterType: any = {};
filterType.regex = 0;
filterType.callback = 1;
filterType[filterType.regex] = "regex";
filterType[filterType.callback] = "callback";

export class FileFilter {
/**
 * @return {?}
 */
public get name(): string {
        return this._name;
    }
/**
 * @return {?}
 */
public get type(): filterType | null {
        return this._type;
    }
private _name = '';
private _regex: RegExp | null = null;
private _regCheck: string | null = null;
private _callback: Function | null = null;
private _type: filterType | null = null;
/**
 * @param {?} name
 * @param {?} _data
 * @param {?=} _regCheck
 */
constructor (name: string, _data: RegExp | Function, _regCheck = 'name') {
        this._name = name;
        if (_data instanceof RegExp) {
            this._type = filterType.regex;
            this._regex = _data;
            this._regCheck = _regCheck;
            return;
        } else if (_data instanceof Function) {
            this._type = filterType.callback;
            this._callback = _data;
            return;
        }
        throw new Error('FilterData is not defined.');
    }
/**
 * @param {?} _file
 * @return {?}
 */
public validate(_file: FileManager): boolean {
        let /** @type {?} */ _valid = false;
        switch (this._type) {
            case filterType.regex: {
                switch (this._regCheck) {
                    case 'name': {
                        if (_file.object.name.match( /** @type {?} */((<RegExp>this._regex)))) {
                            _valid = true;
                        }
                    }break;

                    case 'type': {
                        if (_file.object.type.match( /** @type {?} */((<RegExp>this._regex)))) {
                            _valid = true;
                        }
                    }break;

                    case 'size': {
                        if (( /** @type {?} */((<string> /** @type {?} */((<any>_file.object.size))))).match( /** @type {?} */((<RegExp>this._regex)))) {
                            _valid = true;
                        }
                    }break;

                    case 'date': {
                        // Format for validation is `2017-01-01 10:10:10`
                        // tslint:disable-next-line:max-line-length
                        let /** @type {?} */ _checkDate: string | null = new DatePipe('en-US').transform(_file.object.lastModifiedDate, 'yyyy-MM-dd hh:mm:ss');
                        if (_checkDate && _checkDate.match( /** @type {?} */((<RegExp>this._regex)))) {
                            _valid = true;
                        }
                    }break;

                    default: {
                        throw new Error('RegExp can only check on `name | type | size | date`.');
                    }
                }
            }break;

            case filterType.callback: {
                _valid = ( /** @type {?} */((<Function>this._callback)))(_file);
            }break;

            default: {
                throw new Error('Filter type is not defined.');
            }
        }
        return _valid;
    }
}

function FileFilter_tsickle_Closure_declarations() {
/** @type {?} */
FileFilter.prototype._name;
/** @type {?} */
FileFilter.prototype._regex;
/** @type {?} */
FileFilter.prototype._regCheck;
/** @type {?} */
FileFilter.prototype._callback;
/** @type {?} */
FileFilter.prototype._type;
}

